import { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import api from '../../services/api';
import HeroSlider from '../../components/public/HeroSlider';
import { englishPublicConfig } from '../../utils/publicEnglish';

function onlyDigits(value = '') {
  return String(value || '').replace(/\D/g, '');
}

function buildWhatsappHref(value = '') {
  const phone = onlyDigits(value);
  if (!phone) return '';

  const message = encodeURIComponent(
    'Hello Fresh Exports, I would like information about flower availability and your catalog.'
  );

  return `https://wa.me/${phone}?text=${message}`;
}

export default function PublicHome() {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    config: {},
    slider: []
  });

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const res = await api.get('/api/web/home');

        if (!mounted) return;

        setData({
          config: englishPublicConfig(res?.data?.config || {}),
          slider: Array.isArray(res?.data?.slider) ? res.data.slider.map(englishPublicConfig) : []
        });
      } catch (error) {
        console.error('Error cargando home pública:', error);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const config = data.config || {};
  const whatsappHref = buildWhatsappHref(config.whatsapp_publico || config.telefono_publico);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f8f6f4'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: '#f8f6f4' }}>
      <HeroSlider
        slides={data.slider}
        aboutConfig={config}
        whatsappHref={whatsappHref}
        fallbackTitle={config.hero_titulo || 'Fresh Ecuadorian Flowers'}
        fallbackSubtitle={
          config.hero_subtitulo || 'Premium flowers selected with care for international markets.'
        }
        fallbackButtonText={config.hero_boton_texto || 'View catalog'}
        fallbackButtonLink={config.hero_boton_link || '/catalogo'}
      />

    </Box>
  );
}
